import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import { Web3StatusContext } from "../contexts/Web3StatusContext";
import { Trans } from 'react-i18next';

const { AccountData, ContractData, ContractForm } = newContextComponents;

class AccountInfo extends React.Component {
  static contextType = Web3StatusContext;

  state = { balance: null };

  mounted = false;

  componentDidMount() {
    const { drizzle } = this.props;
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }
  

  // destructure drizzle and drizzleState from props
  render() {
    if(this.context.activeAccount == null) {
      return (
        <button onClick={this.context.connect}>
          <Trans>connect_account</Trans>
        </button>
      );
    }

    this.context.web3.eth.getBalance(this.context.activeAccount, function(err, result) {
      if (err) {
        console.log(err)
      } else {
        if(this.mounted)
          this.setState({balance: this.context.web3.utils.fromWei(result, "ether")});
      }
    }.bind(this));
    
    // using the saved `dataKey`, get the variable we're interested in
    
    
    var balance = this.state.balance;

    if(balance === undefined || balance == null) {
      balance = '--';
    }
    
    return (
      <div>
      {this.context.activeAccount}<br/>
      {balance}{" "}BNB
      </div>
    );
  }
};

export default AccountInfo;